<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-card header-tag="header" header-bg-variant="dark">
            <template #header>
              <p class="mb-0" style="">
                <strong>{{ $store.state.table.penilaian }}</strong>
              </p>
            </template>
            <b-row>
              <b-col cols="12" md="12" lg="12">
                <b-button variant="primary" v-b-modal.modal-input><CIcon name="cil-plus" /> {{ $store.state.table.tambahModal }}</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="12" lg="12">
                <hr />
              </b-col>
            </b-row>

            <b-alert dismissible fade :show="showing" :variant="variant">{{ msg }}</b-alert>

            <b-row>
              <b-col md="3">
                <b-form-group :label="$store.state.table.perHalaman" label-for="per-page-select" label-cols-md="6" label-align-md="left" label-size="md" style="background-color: ">
                  <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="md"></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="6" offset-md="3">
                <b-form-group :label="$store.state.table.cari" label-for="filter-input" label-cols-md="3" label-align-md="right" label-size="md">
                  <b-input-group size="md">
                    <b-form-input id="filter-input" v-model="filter" type="search" :placeholder="$store.state.table.cariHolder"></b-form-input>

                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''" variant="danger">{{ $store.state.table.hapusCari }}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="12" lg="12">
                <b-table
                  :items="items"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  stacked="md"
                  responsive
                  show-empty
                  small
                  @filtered="onFiltered"
                  bordered
                  striped
                  hover
                  :busy="tableBusy"
                >
                  <template #cell(no)="item">{{ item.index + 1 }}</template>
                  <template #cell(actions)="item">
                    <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="'Edit Data'" @click="(data = item.item), edit()"><CIcon name="cil-pencil" /> {{ item.actions }}</b-button>

                    <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="'Hapus Data'" v-b-modal.modal-delete @click="data = item.item"
                      ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
                    >
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="5" offset-md="7">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <modal-input @alert="triggerAlert($event)" :kat="kat" />
    <modal-edit @alert="triggerAlert($event)" :data="data" :kat="kat" />
    <modal-delete @alert="triggerAlert($event)" :data="data" />
  </div>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  name: "penilaian",
  data() {
    return {
      items: [],
      data: [],
      kat: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sortable: true,
          class: "table-number text-center",
        },
        {
          key: "namaKategoriPenilaian",
          label: "Kategori Penilaian",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "penilaian",
          label: "Penilaian",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-2 text-center",
        },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      tableBusy: false,
      showing: false,
      msg: "",
      variant: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  mounted() {
    this.getNilai();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getNilai() {
      let vm = this;
      vm.tableBusy = true;
      let nilai = await vm.$axios.get("masterPenilaian/list");
      vm.items = nilai.data.data;

      let kat = await vm.$axios.get("masterKategoriPenilaian/list");
      vm.kat = kat.data.data;

      vm.tableBusy = false;
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getNilai();
    },
    edit() {
      let vm = this;
      // FOREACH diganti FOR
      // vm.kat.forEach((ele) => {
      //   if (ele.id == vm.data.masterKategoriPenilaianId) {
      //     vm.data.masterKategoriPenilaianIdEdit = ele;
      //   }
      //   vm.$bvModal.show("modal-edit");
      // });
      for (let i = 0; i < vm.kat.length; i++) {
        let x = vm.kat[i];
        if (x.id == vm.data.masterKategoriPenilaianId) {
          vm.data.masterKategoriPenilaianIdEdit = x;
        }
        vm.$bvModal.show("modal-edit");
      }
    },
  },
};
</script>
